import {h} from 'ui/Framework';

export default h('svg', {
  'width': '24',
  'height': '24',
  'xmlns': 'http://www.w3.org/2000/svg',
  'fill': '#fff',
  'fill-rule': 'nonzero'
}, [
  h('path', {
    'd': 'M.5 24a.5.5 0 1 1 0-1h23a.5.5 0 1 1 0 1H.5z'
  }),
  h('path', {
    'd': 'M2 19v4h2v-4H2zm-.5-1h3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zM8 14v9h2v-9H8zm-.5-1h3a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5zM14 16v7h2v-7h-2zm-.5-1h3a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5zM20 9v14h2V9h-2zm-.5-1h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5zM4.06 12.56a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12zm-1.414-1.414a.5.5 0 1 0 .708.708.5.5 0 0 0-.708-.708zM10.06 7.56a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12zM8.647 6.147a.5.5 0 1 0 .708.708.5.5 0 0 0-.708-.708zM16.06 9.56a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12zm-1.414-1.414a.5.5 0 1 0 .708.708.5.5 0 0 0-.708-.708zM22.06 2.56A1.5 1.5 0 1 1 19.94.44a1.5 1.5 0 0 1 2.12 2.12zm-1.414-1.414a.5.5 0 1 0 .708.708.5.5 0 0 0-.708-.708z'
  }),
  h('path', {
    'd': 'M4.09 11.244a.5.5 0 0 1-.64-.768l4.46-3.72a.5.5 0 0 1 .64.768l-4.46 3.72zM9.783 7.295l.314-.95 4.14 1.37-.314.95zM19.97 1.934a.5.5 0 1 1 .76.652l-4.7 5.48a.5.5 0 1 1-.76-.652l4.7-5.48z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-usage.es6.js